import React from 'react';
import { getTrackingData } from '@teko/tracking';
import { MessengerColored } from '@teko/ds-icon';
import { styled } from '@teko/ds-desktop';

interface MessengerProps {
  url: string;
}

const Wrapper = styled.div`
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media print {
    display: none;
  }
`;

export const MessengerIcon: React.FC<MessengerProps> = ({
  url,
}: MessengerProps) => {
  return (
    <Wrapper
      className="fb-chat-full"
      onClick={() => window.open(url, '_blank')}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'quickAction',
        contentName: 'fbMessengerIcon',
        payload: JSON.stringify({ url }),
      })}
    >
      <MessengerColored size={60} />
    </Wrapper>
  );
};
